export default "__VITE_ASSET__7fd747ee__"